export default "__VITE_ASSET__AZ7qi528__"